module.exports = __webpack_public_path__ + "media/application/images/ui/icon-phone-9f43ce016e1d25355e617e151a08d7b7.png";